import type {
    Content,
    ContentCtaFields,
    LightEntrySys,
} from '@beat-venues/common-types';
import type { Metadata } from 'contentful';
import { mockMetadata } from './base.mock';
import { contentPageMock, newsPageMock } from './page-types';

const mockPageSysCtaBase: {
    sys: LightEntrySys;
    metadata: Metadata;
} = {
    sys: {
        id: '4yWuyYwndPHJC7nA6xm7ZQ',
        contentType: {
            sys: {
                id: 'page',
                type: 'Link',
                linkType: 'ContentType',
            },
        },
        locale: 'nl',
    },
    metadata: mockMetadata,
};

export const mockContentCtaBase: Content<'contentCta', ContentCtaFields> = {
    sys: {
        id: '6winRgszgbsg87jY13EgdO',
        contentType: {
            sys: {
                id: 'contentCta',
            },
        },
        locale: 'nl',
    },
    metadata: mockMetadata,
    fields: {
        label: 'Mijn bestellingen',
        noFollow: false,
        name: 'AS - Mijn bestellingen',
    },
};

export const mockContentCtaWithExternalUrl: Content<
    'contentCta',
    ContentCtaFields
> = {
    ...mockContentCtaBase,
    fields: {
        ...mockContentCtaBase.fields,
        externalUrl: 'https://www.teleticketservice.com/nl/account/orders/',
    },
};

export const mockContentCtaWithInternalEntryToContentPage: Content<
    'contentCta',
    ContentCtaFields
> = {
    ...mockContentCtaBase,
    fields: {
        ...mockContentCtaBase.fields,
        internalEntry: {
            ...mockPageSysCtaBase,
            fields: {
                pageType: contentPageMock,
                slug: 'mijn-bestellingen',
            },
        },
    },
};

export const mockContentCtaWithInternalEntryToNewsPage: Content<
    'contentCta',
    ContentCtaFields
> = {
    ...mockContentCtaBase,
    fields: {
        ...mockContentCtaBase.fields,
        label: 'News article',
        internalEntry: {
            ...mockPageSysCtaBase,
            fields: {
                pageType: newsPageMock,
                slug: 'news-article-slug',
            },
        },
    },
};

export const mockContentCtaFull: Content<'contentCta', ContentCtaFields> = {
    ...mockContentCtaBase,
    fields: {
        ...mockContentCtaBase.fields,
        ...mockContentCtaWithExternalUrl.fields,
        ...mockContentCtaWithInternalEntryToContentPage.fields,
    },
};
